import { Injectable } from '@angular/core';
import {
  ApplicationRoutesNgService,
  replaceVars,
  Route,
} from '../../../../../../aptitude/src/main/webapp/src/typescript/modules/core/routeGuard/applicationRoutesNg.service';

export { Route } from '../../../../../../aptitude/src/main/webapp/src/typescript/modules/core/routeGuard/applicationRoutesNg.service';

/**
 * @important: ApplicationRoutesNgService provides the ngJs routes/links
 */
@Injectable({
  providedIn: 'root',
})
export class ApplicationRoutesService extends ApplicationRoutesNgService {
  constructor() {
    super();
  }

  override get(
    routerLink: Route | RouterLinks,
    ...args: Array<string | number>
  ) {
    return replaceVars(routerLink, args);
  }
}

export enum RouterLinks {
  //Sign-In
  SIGN_IN_USERNAME_PASSWORD = '/signIn',
  SIGN_IN_OKTA = '/signIn/protected',
  SIGN_IN_CHOOSE_ORGANIZATION = '/signIn/choose-organization',

  // HOME PAGE REDESIGN LINKS
  HOME_LANDING = '/home/landing',
  HOME_CREATE = '/home/list/BUYER_REQUEST',
  HOME_EXECUTE = '/aptitude/static/home.html#/execute/view/list/filter/activeOpportunities',
  HOME_EXECUTE_NEW = '/home/list/buyer-execute',
  DRAFT_RFP = '/aptitude/static/home.html#/execute/view/list/filter/draftRfps',
  JOINT_CONTRACT = '/aptitude/static/home.html#/execute/view/list/filter/joinGroupContract',

  CATALOG_CATEGORIES = '/home/categories',
  CATALOG_PRODUCTS = '/catalog/categorizationScheme/%categorizationSchemeId%/products',
  CATALOG_PRODUCT_DETAIL = '/catalog/categorizationScheme/%categorizationSchemeId%/category/%categoryId%/product/%productId%',

  PRODUCT_DETAIL = '/aptitude/static/products.html#/view/productID/%productId%',
  EDIT_PRODUCT_DETAIL = '/aptitude/static/products.html#/edit/productID/%productId%',

  MANAGE = '/home/manageList',
  PARTNERS = '/home/partners',
  // External links for Self Help
  SELLER_SELF_HELP = 'https://aptitude-supplier-help.stonly.com/kb/en',
  BUYER_SELF_HELP = 'https://aptitude-provider-help.stonly.com/kb/en',
  RECOMMENDED_SELLER_INITAITED_OFFER = '/home/list/recommendedSellerInitiatedOffer',
  SELLER_RESPOND = '/home/list/sellerRespond',

  // Marketing link
  SELLER_MARKETING_LINK = 'https://events.ringcentral.com/events/access25?utm_source=apt%20supplier%20platform%20card&utm_campaign=apt%20supplier%20platform%20card',
  BUYER_MARKETING_LINK = 'https://events.ringcentral.com/events/access25?utm_source=apt%20buyer%20platform%20card&utm_campaign=apt%20buyer%20platform%20card',

  // MEASUREMENT
  MEASUREMENT_DETAILS = '/measurement/%contractId%/details',
  MEASUREMENT_PRODUCTS = '/measurement/%contractId%/products',
  MEASUREMENT_PARTICIPANTS = '/measurement/%contractId%/participants',
  MEASUREMENT_CATEGORY = '/measurement/%contractId%/category',
  MEASUREMENT_SELLERS = '/measurement/%contractId%/sellers',

  // RFP/..
  RFP_BULLETIN_BOARD = '/rfp/%rfpId%/bulletin-board',
  RFP_CATEGORIES = '/rfp/%rfpId%/categories',
  RFP_CREATE = '/rfp/create',
  RFP_CREATE_WITH_SELLER = '/rfp/create/withSeller',
  RFP_DETAILS = '/rfp/%rfpId%/details',
  RFP_PARTICIPANTS = '/rfp/%rfpId%/participants',
  RFP_PURCHASE_HISTORY = '/rfp/%rfpId%/purchase-history',
  RFP_SELLERS = '/rfp/%rfpId%/sellers',
  RFP_OFFER_STRUCTURE = '/rfp/%rfpId%/seller-response/offer-structure',
  RFP_OFFER_PRICING = '/rfp/%rfpId%/seller-response/offer-pricing',
  RFP_OFFER_PRICING_DEEP_LINK = '/rfp/%rfpId%/seller-response/offer-pricing/%offerId%',

  //PURCHASE-PLANNING ROUTING
  PURCHASE_PLANNING_COMPARE_OFFERS = '/purchase-planning/%rfp.id%/buyer/compare',
  PURCHASE_PLANNING_DETAILS = '/purchase-planning/%rfp.id%/buyer/ppdetails',
  PURCHASE_PLANNING_OPPORTUNITIES = '/purchase-planning/%rfp.id%/buyer/opportunities',
  PURCHASE_PLANNING_IMPACT = '/purchase-planning/%rfp.id%/buyer/impact',

  // PPI
  PPI_COMPARE_OFFERS = '/purchase-planning/%rfp.id%/purchasePlanning/compare',
  PPI_PURCHASE_PLAN_DETAILS = '/purchase-planning/%rfp.id%/purchasePlanning/ppdetails',

  // Product Downloads
  SEARCH_DOWNLOAD_PATH = '/aptitude/download/products',

  //cross Reference Downloads
  CROSS_REFERENCE_DOWNLOAD_PATH = '/apt-service/downloads/products',

  // ADMIN
  ADMIN_RFPS_LIST = '/admin/rfps/list',
  ADMIN_ALL_AGREEMENTS_LIST = '/admin/allAgreements/list',
  ADMIN_CREATE_CONTRACT = '/admin/contract/create',
  ADMIN_CONTRACT_AUTOMATION_HISTORY = '/admin/contract-automation/list',
  ADMIN_CONTRACT_AUTOMATION_FILES = '/admin/contract-automation/session/%sessionId%/files',
  ADMIN_CREATE_PRODUCT_CATEGORY = '/admin/productCategory/create',
  ADMIN_PRODUCT_CATEGORY_SUBCATEGORIES = '/admin/productCategory/subcategories',
  ADMIN_HOME = '/admin/home',
  ADMIN_CPA_PAGE = '/admin/cpa/details/%contractId%',
  ADMIN_RFP_PAGE = '/admin/rfps/rfp/%rfpId%',
  ADMIN_ORG_PAGE = '/admin/organization/%orgId%',
  ADMIN_USER_PAGE = '/admin/users/user/%userId%',
  ADMIN_CREATE_USER_PAGE = '/admin/users/create',
  ADMIN_CATEGORY_PAGE = '/aptitude/static/platform/admin/productCategory/category/%categoryId%',
  ADMIN_PRODUCT_MANAGEMENT = '/admin/product/management',
  ADMIN_REPORTS = '/admin/misc/reports',

  // Company Settings
  MANAGE_USERS = '/organization/settings/manageUsers',
  SELLER_MANAGE_CATALOG_JS = '/aptitude/seller/SellerManagePricing',
  BUYER_PROFILE_JS = '/aptitude/buyer/EditBuyerProfile',
  SELLER_PROFILE_JS = '/aptitude/seller/EditSellerProfile',
  GROUP_PROFILE_JS = '/aptitude/static/groupProfile.html',
  AGREEMENTS_JS = '/aptitude/static/agreements.html',
  BUYER_DIRECTORY_JS = '/aptitude/static/orgsList.html#/sellers',
  SELLER_DIRECTORY_JS = '/aptitude/static/orgsList.html#/buyers',
}
